export interface Obligation {
  readonly obligationType: ObligationType;
  readonly value: number | null;
}

export enum ObligationType {
  StudyLoans = 'StudyLoans',
  Loans = 'Loans',
  Alimony = 'Alimony'
}
